<div class="data-source-switcher">
  <div class="tab-switcher">
    <button
      class="tab-button"
      [class.active]="activeTab === 'satellites'"
      (click)="setActiveTab('satellites')">
      {{ 'Satellite Images' | translate }}
    </button>
    <button
      class="tab-button"
      [class.active]="activeTab === 'requests'"
      (click)="setActiveTab('requests')">
      {{ 'Requests' | translate }}
    </button>
    <button
      class="tab-button"
      [class.active]="activeTab === 'uploaded'"
      (click)="setActiveTab('uploaded')">
      {{ 'UPLOADED_GEO_IMAGES.TAB_LABEL' | translate }}
    </button>
  </div>
</div>
